import { io, type Socket } from 'socket.io-client';
import { apiClient, tokenStorage } from './api';

export function connectSocket(): Socket {
  const url = import.meta.env.VITE_SOCKET_URL || window.location.origin;
  const socket = io(url, {
    path: import.meta.env.VITE_SOCKET_PATH || '/socket.io',
    auth: { token: tokenStorage.getAccessToken() ?? '' },
    transports: ['websocket', 'polling'],
  });

  socket.on('disconnect', (reason) => {
    if (reason !== 'io server disconnect') return;
    const refreshToken = tokenStorage.getRefreshToken();
    if (!refreshToken) return;
    void apiClient.auth
      .refresh(refreshToken)
      .then((tokens) => {
        tokenStorage.setTokens(tokens);
        socket.auth = { token: tokens.accessToken };
        socket.connect();
      })
      .catch(() => undefined);
  });

  return socket;
}
